module.exports = __webpack_public_path__ + "img/internet.a9ba9b9b.svg";